/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ITiposDivisiones from 'Infotrack@Modelos/smartStock/tiposDivisiones/entidades/tiposDivisiones';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import TiposDivisionesCM from '../controladorModelo/tiposDivisionesCM';
import { acciones, IEstadoTiposDivisiones } from '../reductorTiposDivisiones';
import TiposDivisionesVista from '../vista/tablaTiposDivisionesVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const tiposDivisionesCM = new TiposDivisionesCM();

const TableTiposDivisionesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tiposDivisioness, setTiposDivisioness] = React.useState<ITiposDivisiones[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTiposDivisiones>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTiposDivisiones();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTiposDivisiones = () => {
        manejadorIndicadorCargaGlobal(true);
        tiposDivisionesCM.consultarPorFiltroTiposDivisiones({EmpresaId : idEmpresa}).then((tiposDivisioness) => {
            setTiposDivisioness(modificarPropiedadesTiposDivisiones(tiposDivisioness));
            manejadorIndicadorCargaGlobal(false);
        });
    };

    const modificarPropiedadesTiposDivisiones = (tiposDivisiones: ITiposDivisiones[]) => {
        return tiposDivisiones.map((tipoDivision) => ({
            ...tipoDivision,
            Estado: tipoDivision.Estado !== 1 ? 0 : tipoDivision.Estado,
        }));
    };

    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTiposDivisiones?: ITiposDivisiones) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTiposDivisiones, tipoFormulario } });
    };

    const confirmarEliminacion = (tiposDivisiones: ITiposDivisiones) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTiposDivisiones(tiposDivisiones),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarTiposDivisiones = (tiposDivisiones: ITiposDivisiones) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tiposDivisionesCM.eliminarTiposDivisiones(tiposDivisiones).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TiposDivisionesVista
            tiposDivisioness={tiposDivisioness}
            cargarTiposDivisiones={cargarTiposDivisiones}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTiposDivisionesCV;
